import { Component, OnInit, signal, computed, ChangeDetectionStrategy, inject, DestroyRef, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import { RouterModule } from '@angular/router';

export interface AnnouncementItem {
  badge: string;
  text: string;
  actionText?: string;
  actionUrl?: string;
}

@Component({
  selector: 'app-elite-announcement-bar', 
  standalone: true,
  imports: [CommonModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="relative w-full bg-obsidian-surface border-b border-champagne-gold/20 text-silk-white py-1.5 px-4 overflow-hidden shadow-sm">
      <!-- Fondo con gradiente sutil de oro líquido -->
      <div class="absolute inset-0 bg-gradient-to-r from-champagne-gold/10 via-transparent to-champagne-gold/10 pointer-events-none"></div>

      <div class="max-w-7xl mx-auto flex items-center justify-center text-xs tracking-wide text-center">
        <div class="flex items-center space-x-2 transition-all duration-700 ease-out">
          <span class="px-2 py-0.5 rounded-full bg-champagne-gold/15 text-champagne-gold font-serif font-semibold uppercase tracking-wider text-[10px] border border-champagne-gold/30">
            {{ currentAnnouncement().badge }}
          </span>
          <span class="font-sans font-light text-silk-ivory">
            {{ currentAnnouncement().text }}
          </span>
          @if (currentAnnouncement().actionText) {
            <a [routerLink]="currentAnnouncement().actionUrl || '/tienda'" 
               class="underline decoration-champagne-gold/60 hover:decoration-champagne-gold font-medium text-champagne-gold ml-1 transition-colors">
              {{ currentAnnouncement().actionText }} &rarr;
            </a>
          }
        </div>
      </div>
    </div>
  `
})
export class EliteAnnouncementBarComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private platformId = inject(PLATFORM_ID);

  announcements = signal<AnnouncementItem[]>([
    {
      badge: 'Pruébalo en decant',
      text: 'Pago Contra Entrega solo en Bogotá — Recibe y paga en la comodidad de tu hogar u oficina.',
      actionText: 'Ver catalogo',
      actionUrl: '/tienda'
    }, 
    {
      badge: 'Perfumeria árabe original',
      text: 'Descubre el formato Vial Portátil de Lujo (5ml y 10ml) y evita compras a ciegas.',
      actionText: 'Explorar',
      actionUrl: '/tienda'
    },
    {
      badge: 'Envíos Gratis solo Bogotá',
      text: 'Despachos garantizados a todo el país a través de nuestra alianza logística.',
      actionText: 'Ver más',
      actionUrl: '/tienda'
    }
  ]);  

  currentIndex = signal(0);
  currentAnnouncement = computed(() => this.announcements()[this.currentIndex()]);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      interval(6000)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.currentIndex.update(index => (index + 1) % this.announcements().length);
        });
    }
  }
}
 